import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.spaceLite',
    // Survey Config
    'resource:data.dimensions.spaceSurveyConfigurations.entities.spaceSurveyConfig.attributes.requireSponsoredAccountAssignmentsForSponsoredFunctionalUsages',
    'resource:data.dimensions.spaceSurveyConfigurations.entities.spaceSurveyConfig.attributes.requireFunctionalUsageAssignmentsForSelectedAccounts',
    // Personnel
    'resource:data.dimensions.jobTitles.entities.jobTitle',
    'resource:data.dimensions.jobTitles',
    'resource:data.dimensions.personnel.entities.employee.attributes.jobTitle',
    'resource:data.dimensions.personnel.entities.employee.attributes.organization',
    'resource:data.dimensions.personnel.entities.employee',
    'resource:data.dimensions.personnel',
    // Occupants
    'resource:data.dimensions.personnelSpace.entities.entry.attributes.space',
    'resource:data.dimensions.personnelSpace.entities.entry.attributes.personnel',
    'resource:data.dimensions.personnelSpace.entities.entry',
    'resource:data.dimensions.personnelSpace',
    // GL Account
    'resource:data.dimensions.glAccounts.entities.account',
    'resource:data.dimensions.glAccounts',
    // Sponsor
    'resource:data.dimensions.sponsors.entities.sponsor',
    'resource:data.dimensions.sponsors',
    // Project
    'resource:data.dimensions.projects.entities.project.attributes.sponsor',
    'resource:data.dimensions.projects.entities.project',
    'resource:data.dimensions.projects',
    // Project PI
    'resource:data.dimensions.projectPis.entities.entry.attributes.project',
    'resource:data.dimensions.projectPis.entities.entry.attributes.pi',
    'resource:data.dimensions.projectPis.entities.entry',
    'resource:data.dimensions.projectPis',
    // GL IDC Group
    'resource:data.dimensions.glIdcGroups.entities.group.attributes.idcRate',
    'resource:data.dimensions.glIdcGroups.entities.group.attributes.isOnCampus',
    'resource:data.dimensions.glIdcGroups.entities.group',
    'resource:data.dimensions.glIdcGroups',
    // GL Exp
    'resource:data.dimensions.glExpenses.entities.entry.attributes.idcGroup',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.project',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.account',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.organization',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.amount',
    'resource:data.dimensions.glExpenses.entities.entry',
    'resource:data.dimensions.glExpenses',
    // Payrolls
    'resource:data.dimensions.payrollExpenses.entities.entry.attributes.amount',
    'resource:data.dimensions.payrollExpenses.entities.entry.attributes.gl',
    'resource:data.dimensions.payrollExpenses.entities.entry.attributes.personnel',
    'resource:data.dimensions.payrollExpenses.entities.entry.attributes.unassignedSponsoredAccountsComment',
    'resource:data.dimensions.payrollExpenses.entities.entry.attributes.unassignedSponsoredPeopleComment',
    'resource:data.dimensions.payrollExpenses.entities.entry',
    'resource:data.dimensions.payrollExpenses',
    // Gl IDC Mapping
    'resource:data.dimensions.glExpenseIdcFunctionalization.entities.entry.attributes.expense',
    'resource:data.dimensions.glExpenseIdcFunctionalization.entities.entry.attributes.weight',
    'resource:data.dimensions.glExpenseIdcFunctionalization.entities.entry.attributes.idcFunction',
    'resource:data.dimensions.glExpenseIdcFunctionalization.entities.entry',
    'resource:data.dimensions.glExpenseIdcFunctionalization',
    // Payroll - Space
    'resource:data.dimensions.payrollExpenseSpace.entities.entry.attributes.payrollExpense',
    'resource:data.dimensions.payrollExpenseSpace.entities.entry.attributes.space',
    'resource:data.dimensions.payrollExpenseSpace.entities.entry',
    'resource:data.dimensions.payrollExpenseSpace',
    // Service Centers
    'resource:data.dimensions.serviceCenterFunctionalization.entities.entry.attributes.serviceCenter',
    'resource:data.dimensions.serviceCenterFunctionalization.entities.entry.attributes.spaceFunction',
    'resource:data.dimensions.serviceCenterFunctionalization.entities.entry.attributes.weight',
    'resource:data.dimensions.serviceCenterFunctionalization.entities.entry',
    'resource:data.dimensions.serviceCenterFunctionalization',
    'resource:data.dimensions.serviceCenters.entities.serviceCenter',
    'resource:data.dimensions.serviceCenters',
    // Responsible Person
    'resource:data.dimensions.responsiblePerson.entities.entry.attributes.isPrimary',
    'resource:data.dimensions.responsiblePerson.entities.entry.attributes.space',
    'resource:data.dimensions.responsiblePerson.entities.entry.attributes.personnel',
    'resource:data.dimensions.responsiblePerson.entities.entry',
    'resource:data.dimensions.responsiblePerson',
    // Service Center - Space assignment
    'resource:data.dimensions.serviceCenterSpace.entities.entry.attributes.serviceCenter',
    'resource:data.dimensions.serviceCenterSpace.entities.entry.attributes.space',
    'resource:data.dimensions.serviceCenterSpace.entities.entry',
    'resource:data.dimensions.serviceCenterSpace',
    // Organization Joint Use
    'resource:data.enums.orgJointUseCalculationMode.entries.inherit',
    'resource:data.enums.orgJointUseCalculationMode.entries.salary',
    'resource:data.enums.orgJointUseCalculationMode.entries.manual',
    'resource:data.enums.orgJointUseCalculationMode',
    'resource:data.dimensions.organization.snapshots.jointUse.attributes.activePeriods',
    'resource:data.dimensions.organization.snapshots.jointUse.attributes.calculationMode',
    'resource:data.dimensions.organization.snapshots.jointUse.attributes.manualFunctionalization',
    'resource:data.dimensions.organization.snapshots.jointUse',
    // Clusters
    'resource:data.dimensions.spaceClusters.entities.spaceCluster.attributes.organization',
    'resource:data.dimensions.spaceClusters.entities.spaceCluster',
    'resource:data.dimensions.spaceClusters',
    'resource:data.dimensions.spaceClusterFunctionalization.entities.entry.attributes.cluster',
    'resource:data.dimensions.spaceClusterFunctionalization.entities.entry.attributes.spaceFunction',
    'resource:data.dimensions.spaceClusterFunctionalization.entities.entry.attributes.weight',
    'resource:data.dimensions.spaceClusterFunctionalization.entities.entry',
    'resource:data.dimensions.spaceClusterFunctionalization',
    'resource:data.dimensions.personnelSpaceCluster.entities.entry.attributes.personnel',
    'resource:data.dimensions.personnelSpaceCluster.entities.entry.attributes.cluster',
    'resource:data.dimensions.personnelSpaceCluster.entities.entry',
    'resource:data.dimensions.personnelSpaceCluster',
    'resource:data.dimensions.payrollExpenseSpaceCluster.entities.entry.attributes.payrollExpense',
    'resource:data.dimensions.payrollExpenseSpaceCluster.entities.entry.attributes.cluster',
    'resource:data.dimensions.payrollExpenseSpaceCluster.entities.entry',
    'resource:data.dimensions.payrollExpenseSpaceCluster',
    'resource:data.dimensions.clusterResponsiblePerson.entities.entry.attributes.cluster',
    'resource:data.dimensions.clusterResponsiblePerson.entities.entry.attributes.isPrimary',
    'resource:data.dimensions.clusterResponsiblePerson.entities.entry.attributes.personnel',
    'resource:data.dimensions.clusterResponsiblePerson.entities.entry',
    'resource:data.dimensions.clusterResponsiblePerson',
    'resource:data.dimensions.spaceClusters.snapshots.survey.attributes.comment',
    'resource:data.dimensions.spaceClusters.snapshots.survey.attributes.activePeriods',
    'resource:data.dimensions.spaceClusters.snapshots.survey',
    'resource:data.dimensions.spaceClusterAssignment.entities.entry.attributes.cluster',
    'resource:data.dimensions.spaceClusterAssignment.entities.entry.attributes.space',
    'resource:data.dimensions.spaceClusterAssignment.entities.entry',
    'resource:data.dimensions.spaceClusterAssignment',
    // Labs
    'resource:data.dimensions.spaceLabAssignment.entities.entry.attributes.labService',
    'resource:data.dimensions.spaceLabAssignment.entities.entry.attributes.lab',
    'resource:data.dimensions.spaceLabAssignment.entities.entry',
    'resource:data.dimensions.spaceLabAssignment',
  ],
  description: 'TODO',
  name: 'Data - Space Full',
} as const satisfies core.quiver.Package
